import { AdminLayout, useTranslation } from "@opendash/core";
import { useNavigate } from "@opendash/router";
import { AdminToolbar } from "@opendash/ui";
import { Divider } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketSaveForm } from "../../features/tickets";

export const TicketCreatePage = observer(() => {
  const t = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = React.useState<number | undefined>(
    7 * 24 * 60 * 60 * 1000
  );

  return (
    <>
      <AdminLayout>
        <AdminToolbar title={t("maintenance:menu.tickets.create_label")} />
        <div className="od-page-main">
          <TicketSaveForm
            onSaveSuccess={() => {
              navigate("/openservice/tickets");
            }}
          />
          <Divider />
        </div>
      </AdminLayout>
    </>
  );
});
